import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import TypeAhead from "../AddRole/TypeAhead";
import { MdDelete } from "react-icons/md";
import access_ControlStore from "../../Stores/Access_ControlStores";
import Access_ControlConstants from "../../Constants/Access_ControlConstants";
import Access_ControlActions from "../../Actions/Access_ControlActions";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import ConfirmationPopUp from "../MessageBox/ConfirmationPopUp";
import { useLanguageContext } from "../../Context/LanguageContext";
import { useMessageContext } from "../../Context/SuccessErrorMessageContext";
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
} from "@mui/material";

import {
  useCurrentPageContext,
  usePageSizeContext,
  useMainGridSortContext,
} from "../../Context/GlobalContext";

import EquipmentGroupActions from "../../Actions/EquipmentGroupActions";
import { useItemSelectedFilterContext } from "../../Context/GridEquipListContext";
const EquipmentPopOver = (props) => {
  const parentID = props.selectedItem.id;
  const sortBy = useMainGridSortContext();
  const currentPage = useCurrentPageContext();
  const pageSize = usePageSizeContext();
  const itemSelectedFilter = useItemSelectedFilterContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [searchtext, setSearchText] = useState([]);
  const [selectedEquipmemt, setSelectedEquipmemt] = useState(0);
  const [addButtonEnable, setAddButtonEnable] = useState(false);
  const [childList, setChildList] = useState([]);
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [eventType, setEventType] = useState(null);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [relationshipType, setRelationshipType] = useState("");
  const { localization } = useLanguageContext();
  const [previousApicallString, SetPreviousApicallString] = useState("");
  const tempStoragesearch = useRef("");
  const typeHeadRef = useRef("");

  const getAnlageChildrenByParentId = (parentID) => {
    setGlobalSpinner(true);
    Access_ControlActions.gatAnlageChildren(parentID);
  };

  const addChildToEquipment = (e) => {
    e.preventDefault();

    // Validation: Check if relationship type is selected
    if (!relationshipType) {
      toast.error(localization.pleaseSelectRelationshipType);
      return;
    }

    setGlobalSpinner(true);

    // Handle based on relationship type
    if (relationshipType === "Child") {
      // Child: execute as is
      Access_ControlActions.addAnlageChild(
        props.selectedItem.id,
        selectedEquipmemt
      );
    } else if (relationshipType === "Parent") {
      // Parent: reverse order of parameters
      Access_ControlActions.addAnlageChild(
        selectedEquipmemt,
        props.selectedItem.id
      );
    }

    const filterEquipment = searchtext.filter(
      (items) => items.id !== selectedEquipmemt
    );
    setSearchText(filterEquipment);
  };

  useEffect(() => {
    if (selectedEquipmemt) {
      setAddButtonEnable(false);
    } else {
      setAddButtonEnable(true);
    }
  }, [selectedEquipmemt]);

  useEffect(() => {
    setGlobalSpinner(true);
    Access_ControlActions.gatAnlageChildren(props.selectedItem.id);
  }, [props.selectedItem.id]);

  useEffect(() => {
    function getEqipmentSuccess() {
      var res = access_ControlStore.getEquListToken();
      let equipList = [];
      if (res.length > 0) {
        res.map((key) => {
          equipList.push({
            id: key.id,
            label: key.displayText,
          });
        });
        SetPreviousApicallString(tempStoragesearch.current);
        setSearchText(equipList);
      } else {
        setSearchText([]);
        SetPreviousApicallString(tempStoragesearch.current);
      }
      setGlobalSpinner(false);
    }

    function getEqipmentFailure() {
      setGlobalSpinner(false);
    }

    access_ControlStore.addChangeListener(
      Access_ControlConstants.GET_EQI_LIST_TOKEN_SUCCESS,
      getEqipmentSuccess
    );

    access_ControlStore.addChangeListener(
      Access_ControlConstants.GET_EQI_LIST_TOKEN_FAILURE,
      getEqipmentFailure
    );

    return () => {
      access_ControlStore.removeChangeListener(
        Access_ControlConstants.GET_EQI_LIST_TOKEN_SUCCESS,
        getEqipmentSuccess
      );

      access_ControlStore.removeChangeListener(
        Access_ControlConstants.GET_EQI_LIST_TOKEN_FAILURE,
        getEqipmentFailure
      );
    };
  }, []);

  useEffect(() => {
    function getChildByParentIDSuccess() {
      const res = access_ControlStore.getAnlageChild();
      if (res.length > 0) {
        setChildList(res);
      } else {
        setChildList([]);
      }
      setGlobalSpinner(false);
    }

    function getChildByParentIDSuccessFailure() {
      const res = access_ControlStore.getAnlageChild();
      setGlobalSpinner(false);
    }

    access_ControlStore.addChangeListener(
      Access_ControlConstants.GET_ANLAGE_CHILDREN_SUCCESS,
      getChildByParentIDSuccess
    );

    access_ControlStore.addChangeListener(
      Access_ControlConstants.GET_ANLAGE_CHILDREN_FAILURE,
      getChildByParentIDSuccessFailure
    );

    return () => {
      access_ControlStore.removeChangeListener(
        Access_ControlConstants.GET_ANLAGE_CHILDREN_SUCCESS,
        getChildByParentIDSuccess
      );

      access_ControlStore.removeChangeListener(
        Access_ControlConstants.GET_ANLAGE_CHILDREN_FAILURE,
        getChildByParentIDSuccessFailure
      );
    };
  }, []);

  useEffect(() => {
    function addAnlageChildSuccess() {
      const res = access_ControlStore.getAddAnlageChild();

      if (res) {
        EquipmentGroupActions.getEquipmentList2(
          "EquipList",
          sortBy.order,
          sessionStorage.getItem("eqGId"),
          parseInt(currentPage),
          parseInt(pageSize),
          sortBy.key,
          null,
          itemSelectedFilter
        );
        setGlobalSpinner(false);
        getAnlageChildrenByParentId(props.selectedItem.id);
        toast.success(localization.relationshipAddedSuccess);

        setSelectedEquipmemt("");
        setRelationshipType("");
        typeHeadRef.current.resetTypeHead();
      }
    }
    function addAnlageChildFailur() {
      const res = access_ControlStore.getAddAnlageChild();
      toast.error(res);
      setGlobalSpinner(false);
    }
    access_ControlStore.addChangeListener(
      Access_ControlConstants.ADD_ANLAGE_CHILD_SUCCESS,
      addAnlageChildSuccess
    );

    access_ControlStore.addChangeListener(
      Access_ControlConstants.ADD_ANLAGE_CHILD_FAILURE,
      addAnlageChildFailur
    );

    return () => {
      access_ControlStore.removeChangeListener(
        Access_ControlConstants.ADD_ANLAGE_CHILD_SUCCESS,
        addAnlageChildSuccess
      );

      access_ControlStore.removeChangeListener(
        Access_ControlConstants.ADD_ANLAGE_CHILD_FAILURE,
        addAnlageChildFailur
      );
    };
  }, [itemSelectedFilter]);

  useEffect(() => {
    function removeAnlageChildSuccess() {
      const res = access_ControlStore.getDeleteAnlageChild();
      getAnlageChildrenByParentId(props.selectedItem.id);
      setSearchText([]);
      SetPreviousApicallString("");
      toast.success(localization.relationshipRemoveSuccess);
      setGlobalSpinner(false);
      EquipmentGroupActions.getEquipmentList2(
        "EquipList",
        sortBy.order,
        sessionStorage.getItem("eqGId"),
        parseInt(currentPage),
        parseInt(pageSize),
        sortBy.key,
        null,
        itemSelectedFilter
      );
    }
    function removeAnlageChildSuccessFailur() {
      const res = access_ControlStore.getDeleteAnlageChild();
      toast.error(res);
      setGlobalSpinner(false);
    }
    access_ControlStore.addChangeListener(
      Access_ControlConstants.DELETE_ANLAGE_CHILD_SUCCESS,
      removeAnlageChildSuccess
    );

    access_ControlStore.addChangeListener(
      Access_ControlConstants.DELETE_ANLAGE_CHILD_FAILURE,
      removeAnlageChildSuccessFailur
    );

    return () => {
      access_ControlStore.removeChangeListener(
        Access_ControlConstants.DELETE_ANLAGE_CHILD_SUCCESS,
        removeAnlageChildSuccess
      );

      access_ControlStore.removeChangeListener(
        Access_ControlConstants.DELETE_ANLAGE_CHILD_FAILURE,
        removeAnlageChildSuccessFailur
      );
    };
  }, []);

  function getAnlage(text) {
    setGlobalSpinner(true);
    Access_ControlActions.getAnlages(text, parentID);
  }

  function typeAheadInputChangeCallback(text) {
    if (text.length > 3) {
      if (previousApicallString.length > 0) {
        if (
          !text.toLowerCase().startsWith(previousApicallString.toLowerCase())
        ) {
          getAnlage(text);
          tempStoragesearch.current = text;
        }
      } else {
        getAnlage(text);
        tempStoragesearch.current = text;
      }
    } else {
      if (text === "") {
        setSelectedEquipmemt(0);
      }
    }
  }
  function typeAheadSelectedCallback(selectedList) {
    if (selectedList && selectedList.length > 0) {
      setSelectedEquipmemt(selectedList[0].id);
    }
  }

  function handleSelectedItem() {
    setSelectedEquipmemt("");
  }
  function RenderDeleteButton(props) {
    const id = props.id.id;

    return (
      <MdDelete
        className="mr-4 cursorPoint svgIcon"
        title="delete"
        size={20}
        onClick={() => {
          setConfirmationPopUpOpen(true);
          setConfirmationPopUpMsg(localization.areYouSureYouWantToDelete);
          if (props.id.relationshipType === "Parent") {
            setCallbackData({
              parentId: id,
              childId: parentID,
              childInfo: props.id,
            });
          } else {
            setCallbackData({
              parentId: parentID,
              childId: id,
              childInfo: props.id,
            });
          }
          setEventType("REMOVE_CHILD_FROM_PARENT");
        }}
      />
    );
  }
  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };

  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "REMOVE_CHILD_FROM_PARENT":
          setGlobalSpinner(true);
          Access_ControlActions.deleteAnlageChild(data.parentId, data.childId);
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };
  function handleClose() {
    props.handelPopOverClose();
  }
  return (
    <>
      <div
        className="modal in equipment-modal-overlay"
        id="MsgModalCenter"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="MsgModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog custom-modal-medium" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex w-100 justify-content-between">
                <div className="">
                  {localization.equipment}: {props.selectedItem.inventarnr}
                </div>
                <div className="">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
            </div>
            <div className="modal-body">
              <form
                id="addHerstellerToEquGroupForm"
                name="addHerstellerToEquGroupForm"
                onSubmit={addChildToEquipment}
              >
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={12} md={6}>
                    <div className="form-group">
                      <label className="form-label" htmlFor="hersteller">
                        {localization.searchInfoText}
                      </label>
                      <div className="">
                        <div className="w-100">
                          <TypeAhead
                            ref={typeHeadRef}
                            typeAheadInputChangeCallback={
                              typeAheadInputChangeCallback
                            }
                            typeAheadSelectedCallback={
                              typeAheadSelectedCallback
                            }
                            isMultiple={false}
                            searchedList={searchtext}
                            resetSelectedItem={handleSelectedItem}
                          />
                        </div>
                      </div>
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={12} md={4}>
                    <div className="form-group">
                      <FormControl component="fieldset" fullWidth>
                        <FormLabel component="legend" sx={{ fontSize: 14 }}>
                          {localization.relationshipType}
                        </FormLabel>
                        <RadioGroup
                          row
                          name="relationshipType"
                          value={relationshipType}
                          onChange={(e) => setRelationshipType(e.target.value)}
                        >
                          <FormControlLabel
                            value="Parent"
                            className="customRadioInput"
                            control={<Radio />}
                            label={localization.parent}
                          />
                          <FormControlLabel
                            value="Child"
                            className="customRadioInput"
                            control={<Radio />}
                            label={localization.child}
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={12} md={2}>
                    <div className="form-group">
                      <button
                        type="submit"
                        className="btn btn-primary btn-block equipment-add-button"
                        disabled={addButtonEnable}
                      >
                        {localization.add}
                      </button>
                    </div>
                  </Grid>
                </Grid>

                <div className="mt-5">
                  <h5 className="modal-title">
                    {localization.relatedEquipments}
                  </h5>
                </div>
                <div className="table-responsive equipment-children-table">
                  <table className="table align-middle mb-0 table-striped table-hover table-sticky">
                    <thead className="bg-light">
                      <tr>
                        <th>{localization.inventanrnr}</th>
                        <th>{localization.tag}</th>
                        <th>{localization.status}</th>
                        <th>{localization.Relationship}</th>
                        <th> {localization.action}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {childList?.length == 0 ? (
                        <tr>
                          <td colSpan={100}>
                            <p className="text-center">
                              {localization.noRecordFound}
                            </p>
                          </td>
                        </tr>
                      ) : (
                        childList?.map((row, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                <p className="fw-bold mb-1">{row.inventarNr}</p>
                              </td>
                              <td>
                                <p className="fw-bold mb-1">{row.tag}</p>
                              </td>
                              <td>
                                <p className="fw-bold mb-1">{row.status}</p>
                              </td>
                              <td>
                                <p className="fw-bold mb-1">
                                  {row.relationshipType == "Parent"
                                    ? localization.parent
                                    : localization.child}
                                </p>
                              </td>
                              <td>
                                <RenderDeleteButton id={row} />
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
      />
    </>
  );
};
export default EquipmentPopOver;
